"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ComparisonProductSelector = _interopRequireDefault(require("./ComparisonProductSelector"));
var _ComparisonDataDisplay = _interopRequireDefault(require("./ComparisonDataDisplay"));
var _useComparisonSpecs = _interopRequireDefault(require("../../hooks/comparison/useComparisonSpecs"));
var _useComparison = _interopRequireDefault(require("../../hooks/comparison/useComparison"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _services = require("../../services");
var _CustomCheckbox = _interopRequireDefault(require("../CustomCheckbox/CustomCheckbox"));
var _GridComparisonView = _interopRequireDefault(require("./GridComparisonView"));
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DisplayDataContainer = _styledComponents.default.div`
  display: ${props => props.notDisplay && 'none'};
`;
const NegativeMarginWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    margin-left: ${props.smallMargin}px;
    margin-right: ${props.smallMargin}px;
    overflow: clip;
    ${_r10SourceLibrary.Mixins.respondTo.md(`margin-left: ${props.meduimMargin}px;margin-right: ${props.meduimMargin}px;`)}
    ${_r10SourceLibrary.Mixins.respondTo.lg(`margin-left: ${props.largeMargin}px;margin-right: ${props.largeMargin}px;`)}
  `);
const ComparisonDataDisplayContainer = _styledComponents.default.div`
  border: 1px solid #bebebe;
  border-radius: 12px;
  overflow: hidden;
  margin: 0 1%;
  & [class*='comparisonRowContainer'] div:last-child {
    [class*='GridRowstyle__GridRow']:last-child {
      .GroupSpecsContainer {
        & div:last-child {
          border-bottom: none;
        }
      }
    }
  }
`;
const ComparisonDataDisplayWrapper = _ref => {
  let {
    specGroups,
    displayedProducts,
    applyShowDifferences
  } = _ref;
  const [groupsWithNoDiff, setGroupsWithNoDiff] = (0, _react.useState)({});
  const [showNoDiffMessage, setShowNoDiffMessage] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const shouldShowNoDiffMessage = applyShowDifferences && Object.values(groupsWithNoDiff).every(Boolean);
    setShowNoDiffMessage(shouldShowNoDiffMessage);
  }, [groupsWithNoDiff, applyShowDifferences]);
  const getValidSpecs = data => data.filter(item => Object.values(item.values).some(value => value.some(element => element.text)));
  if (showNoDiffMessage) return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: 3,
    paddingLevel: 3
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: "center"
  }, _services.Services.locale.localeString('Comparison.NoDiffFound')));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, specGroups.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "comparisonRowContainer"
  }, specGroups.map((group, index) => {
    return getValidSpecs(group.specs).length && group.specs.some(el => !isObjEmpty(el.values)) ? /*#__PURE__*/_react.default.createElement(DisplayDataContainer, {
      key: index,
      notDisplay: groupsWithNoDiff[group.label] && applyShowDifferences
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_ComparisonDataDisplay.default, {
      label: group.label,
      specs: group.specs,
      displayedProducts: displayedProducts,
      applyShowDifferences: applyShowDifferences,
      onNoDiff: isNoDiff => {
        setGroupsWithNoDiff(oldGroups => ({
          ...oldGroups,
          [group.label]: isNoDiff
        }));
      }
    })))) : null;
  })) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    justify: "center"
  }, _services.Services.locale.localeString('Comparison.NoDataFound')));
};
const isObjEmpty = obj => Object.keys(obj).length === 0;
const ComparisonBody = () => {
  const {
    displayedProducts,
    showPlans,
    showBusinessSolution
  } = (0, _useComparison.default)();
  const {
    specGroups
  } = (0, _useComparisonSpecs.default)();
  const shouldAddTableBorders = (0, _useLocalTheme.default)(`comparison.addTableBorders`, false);
  const [checkShowDifferences, setCheckShowDifferences] = (0, _react.useState)(false);
  const showDifferences = (0, _useLocalTheme.default)(`comparison.showDifferences`, false);
  const withGridView = (0, _useConfig.default)('comparisonSettings.withGridView', false);
  const meduimMargin = (0, _useLocalTheme.default)('comparison.margin.md', -32);
  const largeMargin = (0, _useLocalTheme.default)('comparison.margin.lg', -40);
  const smallMargin = (0, _useLocalTheme.default)('comparison.margin.sm', -24);
  const showGridView = (showPlans || showBusinessSolution) && withGridView;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, showGridView ? /*#__PURE__*/_react.default.createElement(_GridComparisonView.default, {
    displayedProducts: displayedProducts
  }) : /*#__PURE__*/_react.default.createElement(NegativeMarginWrapper, {
    meduimMargin: meduimMargin,
    largeMargin: largeMargin,
    smallMargin: smallMargin
  }, /*#__PURE__*/_react.default.createElement(_ComparisonProductSelector.default, {
    displayedProducts: displayedProducts
  }), showDifferences && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      left: 2,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_CustomCheckbox.default, {
    id: "showDiff",
    testId: "show-differences-title",
    inputSize: 20,
    textSize: 2,
    textJustify: "center",
    checked: checkShowDifferences,
    text: _services.Services.locale.localeString('Comparison.ShowDifferences'),
    onChange: () => {
      setCheckShowDifferences(!checkShowDifferences);
    }
  })), shouldAddTableBorders ? /*#__PURE__*/_react.default.createElement(ComparisonDataDisplayContainer, null, /*#__PURE__*/_react.default.createElement(ComparisonDataDisplayWrapper, {
    specGroups: specGroups,
    displayedProducts: displayedProducts,
    applyShowDifferences: checkShowDifferences
  })) : /*#__PURE__*/_react.default.createElement(ComparisonDataDisplayWrapper, {
    specGroups: specGroups,
    displayedProducts: displayedProducts,
    applyShowDifferences: checkShowDifferences
  }))));
};
var _default = ComparisonBody;
exports.default = _default;